export default "__VITE_ASSET__B4u0V3$Z__"